import { render, staticRenderFns } from "./DataFModel.vue?vue&type=template&id=54910069&scoped=true"
import script from "./DataFModel.vue?vue&type=script&lang=js"
export * from "./DataFModel.vue?vue&type=script&lang=js"
import style0 from "./DataFModel.vue?vue&type=style&index=0&id=54910069&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54910069",
  null
  
)

export default component.exports